/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown>, error: NonNullable<unknown> }} Explorer_Kanban_Open_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to open {type}: {error}" |
*
* @param {Explorer_Kanban_Open_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_open_failed_toast = /** @type {((inputs: Explorer_Kanban_Open_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Open_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec d'ouverture de ${i?.type} : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Öffnen von ${i?.type}: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aprire ${i?.type}: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось открыть ${i?.type}: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo abrir ${i?.type}: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`打开 ${i?.type} 失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.type} を開けませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.type} खोलने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao abrir ${i?.type}: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to open ${i?.type}: ${i?.error}`)
});